import { useState, useEffect } from 'react'

type DeviceState = {
  isEnabled: boolean
  toggle: () => void
}

export const useDeviceState = (key: string, defaultValue: boolean = true): DeviceState => {
  const [isEnabled, setIsEnabled] = useState<boolean>(() => {
    try {
      const saved = localStorage.getItem(key)
      return saved !== null ? saved === 'true' : defaultValue
    } catch {
      return defaultValue
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(key, String(isEnabled))
    } catch {
      //
    }
  }, [isEnabled, key])

  const toggle = () => setIsEnabled((prev) => !prev)

  return { isEnabled, toggle }
}
